import { render, staticRenderFns } from "./SideLeft.vue?vue&type=template&id=38b417b3&scoped=true&"
import script from "./SideLeft.vue?vue&type=script&lang=ts&"
export * from "./SideLeft.vue?vue&type=script&lang=ts&"
import style0 from "./SideLeft.vue?vue&type=style&index=0&id=38b417b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b417b3",
  null
  
)

export default component.exports